export { default } from './id-doc-country-and-type';
